import { NgModule } from '@angular/core';
import { AsMoneyPipe } from './as-money.pipe';
import { ConcealSSNPipe } from './conceal-ssn.pipe';
import { FacadeLangKeyPipe } from './facade-lang-key.pipe';
import { IntervalPipe } from './interval.pipe';
import { LocalDatePipe } from './local-date.pipe';
import { MoneyPipe } from './money.pipe';
import { MonthsPipe } from './months.pipe';
import { RenderCollapsibleMarkdownPipe } from './render-collapsible-markdown.pipe';
import { RenderMarkdownPipe } from './render-markdown.pipe';
import { SimpleMarkdownPipe } from './simple-markdown.pipe';
import { ToArrayPipe } from './to-array.pipe';
import { WeeksPipe } from './weeks.pipe';

@NgModule({
	imports: [],
	declarations: [
		AsMoneyPipe,
		FacadeLangKeyPipe,
		MoneyPipe,
		ToArrayPipe,
		SimpleMarkdownPipe,
		ConcealSSNPipe,
		MonthsPipe,
		WeeksPipe,
		IntervalPipe,
		RenderMarkdownPipe,
		RenderCollapsibleMarkdownPipe,
		LocalDatePipe,
	],
	exports: [
		AsMoneyPipe,
		FacadeLangKeyPipe,
		MoneyPipe,
		ToArrayPipe,
		SimpleMarkdownPipe,
		ConcealSSNPipe,
		MonthsPipe,
		WeeksPipe,
		IntervalPipe,
		RenderMarkdownPipe,
		RenderCollapsibleMarkdownPipe,
		LocalDatePipe,
	],
})
export class ApplicationPipesModule {}
